const FAT = {
  listURL: 'https://bbs.zhangmen.com',
  wwwURL: '/1v1/api',
  parentURL: 'http://appapi-test.zmlearn.com',
  statisticsURL: 'https://statistics-test.zmlearn.com',
  marketURL: 'https://market-test.zmlearn.com',
  evaluateURL: '/1v1/api',
  nodeHost: '/node-host',
  appGateway: 'https://operation-gateway-test.zmlearn.com',
  bannerGroupID: '5b333d957c15aa7c5b08f2ee',
  bannerGroupIDV: '5b401f9c3082c1036e700e4b',
  bannerGroupIDBY: '5bacae174a45f027353669f4',
  bannerGroupIDFEED: '5bacae0fd77a422d9c223d16',
  bannerGroupIDSEM: '5bcdca1f1566801d22e992ca',
  learnCenterAppid: 'wxd55c78a022bda34d',
  ferrariClient:'http://operation-ferrari-client-fat.zmlearn.com'
}

const UAT = {
  listURL: 'https://bbs.zhangmen.com',
  wwwURL: 'https://www.uat.zmops.cc/api',
  parentURL: 'https://appapi.zmlearn.com',
  statisticsURL: 'https://statistics.zmlearn.com',
  marketURL: 'https://market.zmlearn.com',
  evaluateURL: 'https://www.zhangmen.com/api',
  nodeHost: '/node-host',
  appGateway: 'https://operation-gateway.uat.zmops.cc',
  bannerGroupID: '5b333d957c15aa7c5b08f2ee',
  bannerGroupIDV: '5b401f9c3082c1036e700e4b',
  bannerGroupIDBY: '5bacae174a45f027353669f4',
  bannerGroupIDFEED: '5bacae0fd77a422d9c223d16',
  bannerGroupIDSEM: '5bcdca1f1566801d22e992ca',
  learnCenterAppid: 'wxd55c78a022bda34d',
  ferrariClient:'http://operation-ferrari-client-fat.zmlearn.com'
}

const PRO = {
  listURL: 'https://bbs.zhangmen.com',
  wwwURL: 'https://www.zhangmen.com/api',
  parentURL: 'https://appapi.zmlearn.com',
  statisticsURL: 'https://statistics.zmlearn.com',
  marketURL: 'https://market.zmlearn.com',
  evaluateURL: 'https://www.zhangmen.com/api',
  nodeHost: '/node-host',
  appGateway: 'https://operation-gateway-internal-ng.zmlearn.com',
  bannerGroupID: '5b333d957c15aa7c5b08f2ee',
  bannerGroupIDV: '5b401f9c3082c1036e700e4b',
  bannerGroupIDBY: '5bacae174a45f027353669f4',
  bannerGroupIDFEED: '5bacae0fd77a422d9c223d16',
  bannerGroupIDSEM: '5bcdca1f1566801d22e992ca',
  learnCenterAppid: 'wx05a6da34898c1349',
  ferrariClient:'http://operation-ferrari-client.zmlearn.com'
}

let config;

if (process.env.NODE_ENV === 'production') {
  config = PRO
} else if (process.env.NODE_ENV === 'uat') {
  config = UAT
} else {
  config = FAT
}

export default config
